import type { CatchGrant } from "@highmarch/app";
import type { PetData } from "@highmarch/domain";
import { rowHtml } from "../components";
import { petPortraitHtml } from "./petArt";
import { catchWords } from "./petWords";

/** The portrait's size on the row: a little over the other extras' painted icons (28 px, features/events.ts), as a face. */
const LEAD_PX = 34;

/**
 * The end screen's catch row (Pets v2, docs/PETS.md), a compact cream row like the other end-screen extras (end.css
 * `.erow`): the pet's portrait, what the catch paid (the pet, a level, or gold at the cap) and the skin it wore. Nothing
 * on a battle without a catch (features/pets.ts gives "" then); the moment itself is the mid-battle catch card (petMomentUi.ts).
 */
export function catchBlockHtml(grant: CatchGrant, pet: PetData): string {
  const w = catchWords(grant, pet);
  return rowHtml({
    lead: petPortraitHtml(pet.id, LEAD_PX), title: w.title, sub: w.sub, compact: true,
    end: w.end ? `<span class="pcr-up disp">${w.end}</span>` : "", className: "erow gain petcatchrow up",
  });
}
